import { createAction } from "@reduxjs/toolkit";

import {
  getLikesListActionTypes,
  getLikesListPortionActionTypes,
} from "./actionTypes";

export const getLikesList = createAction(
  getLikesListActionTypes.request,
  (payload) => ({ payload }),
);

export const getLikesListSuccess = createAction(
  getLikesListActionTypes.success,
  (payload) => ({ payload }),
);

export const getLikesListFailure = createAction(
  getLikesListActionTypes.failure,
  (error) => ({ payload: error }),
);

export const getLikesListPortion = createAction(
  getLikesListPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getLikesListPortionSuccess = createAction(
  getLikesListPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getLikesListPortionFailure = createAction(
  getLikesListPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const likesListReset = createAction(getLikesListActionTypes.reset);
